import React, {useContext, useEffect, useRef, useState} from 'react';
import Lang from '../Lang/Lang';
import {ClientWidthContext} from '../Context/ApplicationContextProvider';
import {
  axiosInstance,
  eventEmitter,
  sessid,
  lang,
  apiBaseUrl, underlineClass, hoverUnderlineClass, hoverBtnClass,
} from '../../common/baseData';
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import BasketIcon from './images/basket_black.svg'
import './AbandonedCart.css'

function AbandonedCart(props) {
  const clientWidth = useContext(ClientWidthContext);
  const swiperClass = 'swiper-abandoned-cart';
  const [swiperInstance, setSwiperInstance] = useState(null);

  // Получение cookies
  const getCookie = (name) => {
    const cookies = document.cookie.split(';').reduce((acc, cookie) => {
      const [key, value] = cookie.trim().split('=');
      acc[key] = value;
      return acc;
    }, {});
    return cookies[name];
  };

  // Инициализация состояния видимости корзины из cookies
  const hiddenUntil = parseInt(getCookie('abandonedCartHiddenUntil'), 10) || 0;
  const currentTime = Math.floor(Date.now() / 1000);
  const initialCartVisible = hiddenUntil <= currentTime;

  const [state, setState] = useState(window.abandonedCartData || {
    items: null,
    price: null,
    titleItemsCountLang: '',
    firstItem: null,
    orderLink: '#',
  });

  const [isCartVisible, setCartVisible] = useState(initialCartVisible); // Состояние видимости корзины

  const url = `${apiBaseUrl}basket/abandoned`;

  // Установка значения cookies
  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()}`;
  };

  // basket update event
  useEffect(() => {
    eventEmitter.on('basketUpdated', getBasketState);

    return () => {
      eventEmitter.off('basketUpdated', getBasketState);
    }
  }, []);

  useEffect(() => {
    if (!swiperInstance) return;
    swiperInstance.update();
  }, [clientWidth, swiperInstance, state.items?.length]);

  // Loading component data
  function getBasketState() {
    axiosInstance.post(url).then(response => response.data).then(response => {
      setState({
        ...state,
        firstItem: response.firstItem,
        items: response.items,
        price: response.price,
        titleItemsCountLang: response.titleItemsCountLang,
        orderLink: response.orderLink,
      });
    });
  }

  // Функция для закрытия корзины
  function closeAbandonedCart(e) {
    e.preventDefault();
    setCartVisible(false); // Устанавливаем видимость в false
    const nextWeek = Math.floor(Date.now() / 1000) + (7 * 24 * 60 * 60); // Текущее время + 7 дней (UNIX timestamp)
    setCookie('abandonedCartHiddenUntil', nextWeek, 7); // Сохраняем в cookie
  }

  const isDesktop = clientWidth >= 1280;
  const heedClampTitle = Array.isArray(state.items) && state.items.length > 2;
  const desktopClass = `${heedClampTitle
    ? 'line-clamp-2 overflow-hidden w-auto'
    : ''} font-normal text-[12px] leading-[18px] text-grey-90 ${hoverUnderlineClass}`;

  // Условие отображения корзины
  const shouldRenderCart = !Array.isArray(state.items) || !state.items.length || !isCartVisible;
  const maxSlides = 3;
  const slidesCount = Array.isArray(state.items) ? Math.min(state.items.length, maxSlides) : 1.5;
  return (
    !shouldRenderCart && (
      <div
        className="relative mx-5 bg-[#F9F4FF] py-[9.5px] px-2 rounded-[14px] desktop:mx-0 flex justify-between items-center desktop:border-none desktop:px-4">
        {Array.isArray(state.items) && state.items.length > 0 && (
          <>
            <span
              className="flex shrink-0 items-center gap-2 text-black font-normal text-[14px] leading-[21px] desktop:text-[13px] desktop:leading-[20px] desktop:min-w-[160px] desktop:max-w-[160px] 400:text-[12px] 400:leading-[16px]">
                <img width="23px" height="23px" src={BasketIcon} alt=""/>
                <span className="min-w-[72px] max-w-[72px] font-medium block desktop:max-w-none 400:max-w-[60px] 400:min-w-[60px] desktop:min-w-none">{state.titleItemsCountLang}</span>
            </span>
            <div
              className="abandoned-list pr-2 pl-2 desktop:order-2 w-full overflow-hidden scroll-smooth snap-x snap-mandatory overscroll-x-none invisible-scrollbar cursor-col-resize phone:flex-wrap phone:max-h-[40px] phone:overflow-hidden desktop:px-[35px] phone:w-auto">
              <Swiper
                modules={[FreeMode, Navigation]}
                key={slidesCount}
                onSwiper={setSwiperInstance}
                navigation={{
                  prevEl: `.swiper-button-prev-abandoned.${swiperClass}`,
                  nextEl: `.swiper-button-next-abandoned.${swiperClass}`,
                }}
                freeMode={true}
                speed={600}
                slidesPerView={clientWidth < 500 ? 'auto' : 'auto'}
                spaceBetween={8}
                breakpoints={{
                  500: { slidesPerView: slidesCount, spaceBetween: 8 },
                  767: { slidesPerView: slidesCount, spaceBetween: 8 },
                  1280: { slidesPerView: slidesCount, spaceBetween: 20, freeMode: false },
                }}
              >
                {state.items.map((item) => (
                  <SwiperSlide key={`abandoned-item-${item.recId}`}>
                    <div className="flex gap-2 items-center">
                      <span className="flex items-center justify-center border-solid border-[0.5px] border-grey-15 bg-white overflow-hidden rounded-[12px] h-10 w-10 min-w-10">
                        <img src={item.image} className="h-full w-full object-cover" width="32px" height="32px" loading="eager"/>
                      </span>
                      <a href={item.link} className={`line-clamp-2 500:hidden ${desktopClass}`}>{item.name}</a>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className={`swiper-button-prev-abandoned ${swiperClass} ${!isDesktop ? '!hidden' : ''}`}/>
              <div className={`swiper-button-next-abandoned ${swiperClass} ${!isDesktop ? '!hidden' : ''}`}/>
            </div>
            <a href={state.orderLink}
               className={`desktop:min-w-[123px] desktop:w-[123px] text-center relative bg-blue-primary px-4 text-white text-[14px] leading-[21px] py-3 border-0 rounded-[14px] mr-[20px] desktop:order-3 desktop:ml-[22px] desktop:mr-[35px] 400:text-[12px] 400:leading-[16px] 400:py-2.5 hover:bg-blue-hover ${hoverBtnClass}`}>
              <span>{Lang.getMessage('makeOrder')}</span>
            </a>
            <a href={"#"} className={`absolute top-1/2 -translate-y-1/2 border-none right-2 desktop:right-4`}
               onClick={closeAbandonedCart}>
              <i className="ic-close-sm"></i>
            </a>
          </>
        )
      }
    </div>
    )
  );
}

export default AbandonedCart;